// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pane_container[data-v-7945ef93] {\n  background: #fff;\n  padding: 10px;\n}\n.pane_container .box_description[data-v-7945ef93] .el-descriptions__title {\n  font-size: 14px;\n  color: #1890ff;\n  border-bottom: 2px solid #1890ff;\n}\n.pane_container .box_description[data-v-7945ef93] .el-descriptions__header {\n  border-bottom: 1px dashed #ddd;\n}", ""]);
// Exports
module.exports = exports;
